import { Subject } from 'rxjs';

import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { FsMapControlsModes } from '@lib/geo/helpers';
import { FsMapControlsService } from '@lib/geo/map/services';
import { SnLayoutService } from '@lib/ui/layout';

import { FsMap, FsMapDrawingControlsType } from '../../types';

@Component({
  selector: 'fs-map-controls',
  templateUrl: './map-controls.component.html',
  styleUrls: ['./map-controls.component.scss'],
})
export class MapControlComponent implements OnDestroy, OnInit {
  @Input() public map: FsMap;
  @Input() public mapStyle: string;
  @Input() public styleControls: boolean;
  @Input() public zoomControls: boolean;
  @Input() public drawingControls: FsMapDrawingControlsType;
  @Input() public toggleControls: boolean;
  @Input() public miniMap: boolean;

  @Input() public position: 'top' | 'right' = 'right';

  @Output() public drawingToolEventEmitter = new EventEmitter();

  public isHidden: boolean = false;
  public tabHidden: boolean = true;

  private readonly _destroy$: Subject<void> = new Subject();

  constructor(public layout: SnLayoutService, private mapControlService: FsMapControlsService) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public zoomIn(): void {
    this.mapControlService.zoomIn(this.map);
  }

  public zoomOut(): void {
    this.mapControlService.zoomOut(this.map);
  }

  public setStyle(style: string): void {
    this.mapControlService.setStyle(this.map, style);
  }

  public freehand(): void {
    this.drawingToolEventEmitter.emit('freehand');
    this.mapControlService.drawFreehand(this.map);
  }

  public drawCircle(): void {
    this.drawingToolEventEmitter.emit('circle');
    this.mapControlService.drawCircle({
      map: this.map,
      mode: FsMapControlsModes.MainMapSearch,
    });
  }

  public drawPoint(): void {
    this.drawingToolEventEmitter.emit('point');
    this.mapControlService.drawPoint({
      map: this.map,
      mode: FsMapControlsModes.MainMapSearch,
    });
  }

  public drawPolygon(): void {
    this.drawingToolEventEmitter.emit('polygon');
    this.mapControlService.drawPolygon({
      map: this.map,
      mode: FsMapControlsModes.MainMapSearch,
    });
  }

  public drawPolyline(): void {
    this.drawingToolEventEmitter.emit('polyline');
    this.mapControlService.drawPolyline({
      map: this.map,
      mode: FsMapControlsModes.MainMapSearch,
    });
  }

  public drawRectangle(): void {
    this.drawingToolEventEmitter.emit('rectangle');
    this.mapControlService.drawRectangle({
      map: this.map,
      mode: FsMapControlsModes.MainMapSearch,
    });
  }

  public toggleMapControls(): void {
    this.isHidden = !this.isHidden;
    this.tabHidden = !this.tabHidden;
  }
}
